import { RootState } from '@checkout/state';
import { Field } from 'formik';
import * as React from 'react';
import { ChangeEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import messages from '../../../i18n/base-en';
import { personalIdentityNumberFetchRequest } from '../../../reducers/checkout';
import { Button, InputField } from '../../presentational';

import * as Styles from './PersonalIdentityNumber.scss';

interface IOwnProps {
  id: string;
  name: string;
}

interface IConnectedProps {
  selectedPaymentMethod: string;
  identityNumber?: string;
}

interface IConnectetDispatchProps {
  personalIdentityNumberFetchRequest: typeof personalIdentityNumberFetchRequest;
}

interface IOwnState {
  value: string;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class PersonalIdentityNumber extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    value: this.props.identityNumber || '',
  };

  handleChange = (event: ChangeEvent<any>) => {
    const { value } = event.target;

    this.setState({
      value,
    });
  }

  handleFetchData = () => {
    this.props.personalIdentityNumberFetchRequest({
      paymentMethod: this.props.selectedPaymentMethod,
      identityNumber: this.state.value,
    });
  }

  render() {
    const { id, intl } = this.props;
    const { value } = this.state;
    const { formatMessage } = intl;

    return (
      <div className={Styles.inputWrapper}>
        <div className={Styles.input}>
          <Field
            id={id}
            name={id}
            component={InputField}
            value={value}
            type="text"
            variant="simple"
            onChange={this.handleChange}
            submitOnEnter={true}
            label={formatMessage(messages.pin_input_label)}
            placeholder={formatMessage(messages.pin_input_placeholder)}
          />
        </div>
        <Button
          align="left"
          type="button"
          label={formatMessage(messages.pin_fetch_button_label)}
          variant="primary"
          onClick={this.handleFetchData}
          disabled={!value}
        />
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      selectedPaymentMethod: state.checkout.selection.paymentMethod,
      identityNumber: state.checkout.fieldsData.shippingAddress && state.checkout.fieldsData.shippingAddress.identityNumber,
    }),
    {
      personalIdentityNumberFetchRequest
    }
  ),
)(PersonalIdentityNumber);
